import HidePages from './HidePages';

export default HidePages;
